function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.344 45.36a.658.658 0 01-.584.724c-.843.09-1.7.137-2.569.137a.658.658 0 010-1.315c.821 0 1.632-.044 2.43-.13a.658.658 0 01.723.584zM6.008 6.126c0-1.015.84-1.806 1.838-1.806h5.496c1.268 0 2.326 1.003 2.326 2.28v5.348c0 1.013-.838 1.804-1.834 1.806-.483 0-.948-.186-1.295-.523l-.728-.708c-2.787 2.925-4.488 6.831-4.488 11.124 0 7.47 5.15 13.791 12.213 15.757.35.097.569.45.485.804a.64.64 0 01-.79.476c-7.62-2.099-13.223-8.922-13.223-17.037 0-4.895 2.044-9.32 5.336-12.52l.459-.447 1.653 1.609c.097.093.231.15.377.15.304-.001.52-.237.52-.49V6.6c0-.517-.435-.966-1.011-.966H7.846a.507.507 0 00-.523.49c0 .125.051.248.147.341l1.732 1.685-.484.471c-3.958 3.85-6.403 9.16-6.403 15.025 0 10.978 8.571 20.036 19.596 21.145.361.037.635.35.61.712a.645.645 0 01-.704.6C10.138 44.948 1 35.35 1 23.647c0-6 2.407-11.45 6.323-15.49l-.77-.748a1.79 1.79 0 01-.545-1.283z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.035 40.43c.05-.36.382-.61.741-.56.789.109 1.595.166 2.415.166a.657.657 0 110 1.315c-.88 0-1.748-.062-2.596-.18a.657.657 0 01-.56-.741zM20.657 1.86a.658.658 0 01.583-.723c.844-.09 1.7-.137 2.569-.137a.658.658 0 110 1.315c-.82 0-1.631.044-2.429.13a.658.658 0 01-.723-.584zM41.992 41.095c.001 1.015-.84 1.807-1.837 1.807h-5.496c-1.268 0-2.327-1.004-2.327-2.281v-5.348c0-1.013.838-1.804 1.834-1.805h.001c.482 0 .948.185 1.294.522l.728.708c2.787-2.925 4.489-6.83 4.489-11.124 0-7.47-5.15-13.791-12.213-15.757a.678.678 0 01-.485-.804.64.64 0 01.789-.476c7.621 2.1 13.224 8.922 13.224 17.037 0 4.896-2.045 9.32-5.337 12.521l-.458.446-1.654-1.608a.541.541 0 00-.377-.15.507.507 0 00-.52.49v5.348c0 .517.435.966 1.012.966h5.495a.507.507 0 00.523-.49v-.001a.475.475 0 00-.146-.34l-1.733-1.686.485-.47c3.958-3.85 6.402-9.16 6.402-15.026 0-10.977-8.57-20.035-19.596-21.145a.674.674 0 01-.609-.712.645.645 0 01.703-.6c11.68 1.157 20.818 10.755 20.818 22.457 0 6-2.407 11.45-6.324 15.49l.77.749c.347.337.545.798.545 1.282z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.966 6.791a.657.657 0 01-.742.561 17.546 17.546 0 00-2.415-.167.658.658 0 110-1.315c.881 0 1.748.062 2.596.18.36.05.61.382.56.741zM33.072 22.673c.346 0 .625.28.625.625v5.481c0 .463-.314.866-.763.979h-.001l-9.852 2.493-.01.002c-.096.02-.226.045-.375.045a1.48 1.48 0 01-.308-.03l-7.257-1.4c-.001 0 0 0 0 0a1.036 1.036 0 01-.841-1.017v-5.219a.625.625 0 111.25 0v5.042l7.1 1.369.007.002h.01c.008.002.02.002.04.002a.509.509 0 00.1-.014l9.65-2.442v-5.293c0-.345.28-.625.625-.625zm-17.706 6.968z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.282 16.018a.625.625 0 01-.558.686l-6.753.695-4.829 7.103a.625.625 0 11-1.034-.703l4.856-7.144.002-.003c.193-.277.498-.459.837-.493l6.793-.699a.625.625 0 01.686.558z",
  fill: "#2D2D2D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.536 24.368h.003l8.63-1.727.245 1.226-8.628 1.726h-.001a1.78 1.78 0 01-1.843-.775l-4.911-7.556a.625.625 0 011.049-.681l4.91 7.556a.53.53 0 00.546.23z",
  fill: "#2D2D2D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.316 16.436h-.003l-.133-1.078c.118-.008.236-.005.352.007.599.063 1.13.385 1.41.852l4.195 7.001c.161.269.044.592-.26.723-.306.131-.684.02-.844-.249l-4.196-7a.555.555 0 00-.42-.254.583.583 0 00-.101-.002z",
  fill: "#2D2D2D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.696 25.119c.346 0 .626.28.626.625v5.929a.625.625 0 01-1.251 0v-5.93c0-.344.28-.624.625-.624zM17.465 25.628a.072.072 0 00-.072.073v4.847a.625.625 0 01-1.25 0v-4.847a1.323 1.323 0 011.488-1.313l2.113.264a1.546 1.546 0 011.355 1.535v5.075a.625.625 0 11-1.251 0v-5.075a.296.296 0 00-.259-.294l-2.116-.264h-.008zM26.286 15.25v3.08a.625.625 0 11-1.25 0v-3.327c0-.554.449-1.003 1.002-1.003h1.469c.554 0 1.003.449 1.003 1.003v4.44a.625.625 0 11-1.251 0V15.25h-.973z",
  fill: "#2D2D2D"
});

function SvgDevADom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "/img/dev-a-dom.svg";
export { SvgDevADom as ReactComponent };